import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { IPaymentDetailsResponse } from "@/api_framework/api_modals/payment";
import { setPaymentDetails } from "@/app_redux/reducers/slices/auth/inventory_slice";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";

AxiosCurlirize(axios, () => {});

export const usePaymentDetailsAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const dispatch = useAppDispatch();

  const execute = useCallback(
    async (transaction_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .get(`${PAYMENT_MODULE?.PAYMENT_DETAILS?.baseURL}${transaction_id}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IPaymentDetailsResponse>) => {
            if (res.data.status) {
              dispatch(setPaymentDetails({ data: res.data.data }));
              return res.data.data;
            } else {
              dispatch(setPaymentDetails({ data: null }));
              return null;
            }
          })
          .catch((e: AxiosError) => {
            dispatch(setPaymentDetails({ data: null }));
            sendCurl(e.config["curlCommand"]);
            const errorMessage = (e.response?.data as { message?: string })?.message || "An unexpected error occurred";
            toast.error(errorMessage);
            return null;
          });
        return response;
      } catch (error) {
        dispatch(setPaymentDetails({ data: null }));
        if (axios.isAxiosError(error)) {
          captureError(error);
        } else {
          toast.error("Server Error: " + error.message);
        }
        return null;
      }
    },
    [configuration],
  );

  return { execute };
};
